import React, { useState, useEffect } from 'react';
import { User } from 'lucide-react';

export default function TherapistImage({ firstName, lastName, size = 'normal' }) {
  const imageName = `${firstName.trim()}_${lastName.trim()}`;
  // Try the most common extensions first
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'];
  const imagePaths = imageExtensions.map(ext =>
    `${process.env.PUBLIC_URL}/Images/${imageName}${ext}`
  );

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageError, setImageError] = useState(false);

  // Reset fallback state whenever the therapist changes
  useEffect(() => {
    setCurrentImageIndex(0);
    setImageError(false);
  }, [imageName]);

  const handleImageError = () => {
    if (currentImageIndex < imagePaths.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else {
      setImageError(true);
    }
  };

  const sizeClasses = size === 'large'
    ? 'w-64 h-64'
    : 'w-48 h-48';

  return (
    <div className={`${sizeClasses} rounded-2xl overflow-hidden bg-gray-100 flex items-center justify-center`}>
      {!imageError ? (
        <img
          key={currentImageIndex}
          src={imagePaths[currentImageIndex]}
          alt={`${firstName} ${lastName}`}
          className="w-full h-full object-cover"
          onError={handleImageError}
        />
      ) : (
        <User className="w-16 h-16 text-gray-400" />
      )}
    </div>
  );
}
